import { useCallback } from "react";
import { queryKeys } from "../constants/constans";
import { useQuery, useQueryClient } from "react-query";

export default function useSetTimeLineInfo() {
  const queryClient = useQueryClient();
  const { data: timeLineInfo }: any = useQuery(queryKeys.timeLineInfo, () =>
    queryClient.getQueryData(queryKeys.timeLineInfo)
  );
  const setTimeLineInfo = useCallback(
    (timeLineInfo: any[]) =>
      queryClient.setQueryData(queryKeys.timeLineInfo, timeLineInfo),
    [queryClient]
  );

  return { timeLineInfo: timeLineInfo || [], setTimeLineInfo };
}
